import React, { useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { YES, NO } from "const"
import {
    StoreType,
    ChangeUserSettings,
    updateUserSettings,
} from "client/store"
import {
    PageForm,
    FormGroup,
    Label,
    LabelValue,
    Input,
    RadioButton,
    Collapse,
} from "client/components"

import FormatPercentage from "client/pages/sil/format/percentage"
import { customParseInt, customParseFloat } from "client/pages/sil/format/parse"


const IsaTR842022 = () => {
    const settings = useSelector((state: StoreType) => state.userSettings.settings.sil)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [show, setShow] = useState(false)

    const onChange = (value: ChangeUserSettings) => {
        dispatch(updateUserSettings("sil", value))
    }

    const { isaTR842022 } = settings
    const {
        ti,
        di,
        mttr,
        beta,
        safeState,
    } = isaTR842022

    return (
        <Collapse
            show={show}
            title={lang.defaultIsa_tr84_2022_settings}
            onCollapse={() => setShow(!show)}
        >
            <PageForm>
                <FormGroup>
                    <Label>
                        {lang.defaultTI}
                        <LabelValue>{lang.hoursLabel}</LabelValue>
                    </Label>
                    <Input
                        type="text"
                        value={ti}
                        onChange={(e) => onChange({
                            isaTR842022: {
                                ...isaTR842022,
                                ti: e.target.value,
                            },
                        })}
                        onBlur={(e) => onChange({
                            isaTR842022: {
                                ...isaTR842022,
                                ti: customParseInt(e.target.value),
                            },
                        })}
                    />
                </FormGroup>
                <FormGroup>
                    <Label>
                        {lang.defaultDI}
                        <LabelValue>{lang.hoursLabel}</LabelValue>
                    </Label>
                    <Input
                        type="text"
                        value={di}
                        onChange={(e) => onChange({
                            isaTR842022: {
                                ...isaTR842022,
                                di: e.target.value,
                            },
                        })}
                        onBlur={(e) => onChange({
                            isaTR842022: {
                                ...isaTR842022,
                                di: customParseInt(e.target.value),
                            },
                        })}
                    />
                </FormGroup>
                <FormGroup>
                    <Label>
                        {lang.defaultMttr}
                        <LabelValue>{lang.hoursLabel}</LabelValue>
                    </Label>
                    <Input
                        type="text"
                        value={mttr}
                        onChange={(e) => onChange({
                            isaTR842022: {
                                ...isaTR842022,
                                mttr: e.target.value,
                            },
                        })}
                        onBlur={(e) => onChange({
                            isaTR842022: {
                                ...isaTR842022,
                                mttr: customParseInt(e.target.value),
                            },
                        })}
                    />
                </FormGroup>

                <FormatPercentage
                    title={lang.defaultBeta}
                    data={beta}
                    onChange={(value) => onChange({
                        isaTR842022: {
                            ...isaTR842022,
                            beta: customParseFloat(value),
                        },
                    })}
                />

                <FormGroup>
                    <Label>{`${lang.detectedFailuresLeadToSafeState} / ${lang.detectedFailuresLeadToDangerousState}`}</Label>
                    <FormGroup inline>
                        <RadioButton
                            checked={safeState === YES}
                            title={lang.yes}
                            onChange={() => onChange({
                                isaTR842022: {
                                    ...isaTR842022,
                                    safeState: YES,
                                },
                            })}
                        />
                        <RadioButton
                            checked={safeState === NO}
                            title={lang.no}
                            onChange={() => onChange({
                                isaTR842022: {
                                    ...isaTR842022,
                                    safeState: NO,
                                },
                            })}
                        />
                    </FormGroup>
                </FormGroup>
            </PageForm>
        </Collapse>
    )
}
export default IsaTR842022
